var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 0H2a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h1.08v4l5.33-4H16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2m0 11H7.74l-2.66 2v-2H2V2h14Z"
})));
export default SvgChat;